import { docReady } from './utils';
import navbarInit from './bootstrap-navbar';
import detectorInit from './detector';
import navbarDarkenOnScroll from './navbar-darken-on-scroll'
import sendEmail from './sendEmail'


// /* -------------------------------------------------------------------------- */
// /*                            Theme Initialization                            */
// /* -------------------------------------------------------------------------- */

docReady(navbarInit);
docReady(detectorInit);
docReady(navbarDarkenOnScroll);
docReady(sendEmail);
